import React from 'react';
import { useTranslation } from '../../hooks/useTranslation';

const EnergyMeterBanner = ({
  mode,
  setMode,
  majorVersion = '0',
  processVersion = '0.x.x',
  totalRatings = 0,
  hotspotCount = 0,
  isHistorical = false,
}) => {
  const t = useTranslation();
  const tr = (key, fallback) => {
    const val = t(key);
    if (val && val !== key) return val;
    if (fallback !== undefined) return fallback;
    return key;
  };

  return (
    <div className="em-banner">
      <span className="em-banner__brand">
        <i className="fas fa-battery-half"></i>
        {tr('ENERGY_METER', 'ENERGY METER')}
      </span>
      {!isHistorical && (
        <div className="em-segment" role="radiogroup" aria-label="Energy Meter mode">
          <button
            className="em-segment__btn"
            type="button"
            aria-pressed={mode === 'input'}
            onClick={() => setMode('input')}
          >
            <i className="fas fa-pen"></i>
            {tr('INPUT', 'Input')}
          </button>
          <button
            className="em-segment__btn"
            type="button"
            aria-pressed={mode === 'analysis'}
            onClick={() => setMode('analysis')}
          >
            <i className="fas fa-chart-column"></i>
            {tr('ANALYSIS', 'Analysis')}
          </button>
        </div>
      )}
      <span className="em-banner__meta">
        <span className="em-banner__sub">
          {mode === 'analysis'
            ? `${totalRatings} ${tr('RATINGS', 'ratings')} · ${hotspotCount} ${tr('HOTSPOTS', 'hotspots')}`
            : tr('AGGREGATED_ANONYMOUS', 'aggregated · anonymous')}
        </span>
        <span className="em-version-chip">v {processVersion || `${majorVersion}.x.x`}</span>
      </span>
    </div>
  );
};

export default EnergyMeterBanner;
